import React from 'react';
import ReactTooltip from 'react-tooltip';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { LogExportWrapper, LogButton } from './CopyLogButton.style';
import { useCopySupportLogs } from '@Hooks/useCopySupportLogs';
import { CopyIcon } from '@Components/UI/Icons';

const CopyLogButton = ({ error, errorInfo, tooltipPlace }) => {
    const supportHook = useCopySupportLogs(error, errorInfo);

    return (
        <LogExportWrapper>
            <div
                data-tip
                data-for="copy-support-log"
                data-place={tooltipPlace ? tooltipPlace : 'left'}
            >
                <LogButton
                    onMouseOver={() => supportHook.getTrace()}
                    onFocus={() => supportHook.getTrace()}
                    onClick={() => supportHook.ieCopy()}
                    data-testid="copy_support_log_button"
                >
                    <CopyToClipboard
                        text={supportHook.logText}
                        disabled={supportHook.isCopying}
                        onCopy={() => supportHook.setIsCopying(false)}
                    >
                        <CopyIcon style={{ width: '1.2rem', height: '1.2rem' }} />
                    </CopyToClipboard>
                </LogButton>
            </div>
            <ReactTooltip id="copy-support-log" effect="solid" className="white-tooltip">
                <span>Copy support log to clipboard</span>
            </ReactTooltip>
        </LogExportWrapper>
    );
};

export default CopyLogButton;
